import { defineStore, } from 'pinia';
import { computed, ref, } from 'vue';
import { nioJsBridge, } from '@nio-wad/universal-bridge-h5';
import type { UserInfoResult, } from '@nio-wad/universal-bridge-h5/dist/types';
import { getEnv, } from '@/utils/env';

export default defineStore('session', () => {
  const accessToken = ref<string>();

  const isLoggedIn = computed(() => {
    // 开发环境默认已登录
    if (import.meta.env.DEV) {
      return true;
    }

    return Boolean(accessToken.value);
  });

  const setAccessToken = (token: string) => {
    accessToken.value = token
  }

  const getAccessToken = async () => {
    if (localStorage.getItem('token')) {
      return localStorage.getItem('token') || ''
    }

    if (accessToken.value) {
      return accessToken.value;
    }

    // local环境从配置文件中获取token
    if(import.meta.env.VITE_API_TOKEN){
      accessToken.value = import.meta.env.VITE_API_TOKEN;
      return accessToken.value;
    }

    try{
      if ( nioJsBridge.currentInMPContainer() ) {
      console.log('result', nioJsBridge.currentInMPContainer())
      // 不传 env 默认是 prod 环境. ( dev, test, stg, prod )
        nioJsBridge.getWSConnect(getEnv())
      }
      const result:UserInfoResult = (await nioJsBridge.getUserInfo())?.data as UserInfoResult;
      console.log('result', result)
      if (result) {
        accessToken.value = result?.access_token;
      }
    } catch (e) {
      console.log('e', e)
    }

    
    return accessToken.value;
  };

  return {
    isLoggedIn,
    getAccessToken,
    setAccessToken
  };
});
